"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncCreatable = exports.Creatable = exports.Async = exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));

var _emotionTheming = require("emotion-theming");

var _qaSelector = _interopRequireDefault(require("@influitive/qa-selector"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _customStyles = require("./custom-styles");

var _customOptions = _interopRequireDefault(require("./custom-options"));

var _customSingleValue = _interopRequireDefault(require("./custom-single-value"));

var _spinner = _interopRequireDefault(require("../../spinner"));

var _triangle = _interopRequireDefault(require("../../triangle"));

var _inputError = _interopRequireDefault(require("../input-error"));

var _inputLabel = _interopRequireDefault(require("../input-label"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CustomDropdownIndicator = function CustomDropdownIndicator(_ref) {
  var arrowColour = _ref.arrowColour;
  return function (defaultProps) {
    return (0, _core.jsx)(_triangle.default, {
      colour: arrowColour,
      dir: defaultProps.selectProps.menuIsOpen ? 'up' : 'down'
    });
  };
};

var InputWithProps = function InputWithProps(props) {
  return (0, _core.jsx)(_reactSelect.components.Input, _extends({}, props, props.selectProps.inputProps));
};

var CustomLoader = function CustomLoader() {
  return (0, _core.jsx)(_spinner.default, {
    size: "small",
    style: {
      marginRight: '8px'
    }
  });
};

var TypeAhead = function TypeAhead(Component) {
  return (0, _recompose.compose)((0, _recompose.defaultProps)({
    isClearable: true,
    decorator: 'default',
    inputProps: {},
    size: 'normal'
  }), (0, _recompose.setPropTypes)({
    size: _propTypes.default.oneOf(['normal', 'large']),
    options: _propTypes.default.array,
    label: _propTypes.default.string,
    required: _propTypes.default.bool,
    isClearable: _propTypes.default.bool,
    placeholder: _propTypes.default.string,
    isMulti: _propTypes.default.bool,
    isDisabled: _propTypes.default.bool,
    hasError: _propTypes.default.bool,
    errorMessage: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
      return props.hasError;
    }),
    cacheOptions: _propTypes.default.bool,
    defaultOptions: _propTypes.default.bool,
    loadOptions: _propTypes.default.func,
    isLoading: _propTypes.default.bool,
    inputProps: _propTypes.default.object,
    noOptionsMessage: _propTypes.default.string,
    customStyles: _propTypes.default.object,
    decorator: _propTypes.default.oneOf(['individual', 'icon', 'tag', 'default']) // todo: add 'dot'

  }), _emotionTheming.withTheme, (0, _recompose.withProps)(function (_ref2) {
    var _noOptionsMessage = _ref2.noOptionsMessage,
        inputProps = _ref2.inputProps,
        isMulti = _ref2.isMulti,
        isDisabled = _ref2.isDisabled,
        theme = _ref2.theme;
    return {
      noOptionsMessage: function noOptionsMessage() {
        return _noOptionsMessage;
      },
      inputProps: R.mergeDeepRight(_objectSpread({}, inputProps), {
        'data-qa': (0, _qaSelector.default)('typeahead-input', inputProps)
      }),
      closeMenuOnSelect: !isMulti,
      arrowColour: theme.colors.neutral[isDisabled ? 2 : 1]
    };
  }), (0, _recompose.setDisplayName)('TypeAhead'))(function (_ref3) {
    var className = _ref3.className,
        errorMessage = _ref3.errorMessage,
        required = _ref3.required,
        label = _ref3.label,
        selectRef = _ref3.selectRef,
        props = _objectWithoutProperties(_ref3, ["className", "errorMessage", "required", "label", "selectRef"]);

    return (0, _core.jsx)(_inputError.default, {
      errorMessage: errorMessage,
      hasError: props.hasError,
      className: className,
      disabled: props.isDisabled
    }, label && (0, _core.jsx)(_inputLabel.default, {
      id: props.inputProps.id,
      required: required,
      disabled: props.isDisabled
    }, label), (0, _core.jsx)(Component, _extends({}, props, {
      ref: selectRef,
      styles: (0, _customStyles.customStyleObj)(props),
      theme: function theme(_theme) {
        return (0, _customStyles.customizeTheme)(_theme, props);
      },
      components: {
        DropdownIndicator: CustomDropdownIndicator(props),
        Input: InputWithProps,
        LoadingIndicator: CustomLoader,
        SingleValue: (0, _customSingleValue.default)(props.decorator),
        Option: (0, _customOptions.default)(props.decorator)
      }
    })));
  });
};

var _default = TypeAhead(_reactSelect.default);

exports.default = _default;
var Async = TypeAhead(_async.default);
exports.Async = Async;
var Creatable = TypeAhead(_creatable.default, true);
exports.Creatable = Creatable;
var AsyncCreatable = TypeAhead(_asyncCreatable.default, true);
exports.AsyncCreatable = AsyncCreatable;